<template>
  <div>
    <v-layout wrap justify-center mt-12>
      <v-flex xs12 sm9>
        <h1>
          {{ $t('a')}}
        </h1>
      </v-flex>
      <v-flex xs12 text-center>
        <img :src="images.main" height="250px"/>
      </v-flex>
      <v-flex xs12>
        <v-form>
          <v-layout v-if="showProgress" text-center justify-center row wrap>
            <v-flex xs12 class="mt-2">
              <progress id="uploader" value="0" max="100"></progress>
            </v-flex>
          </v-layout>
          <v-layout row wrap justify-center text-center class="pb-2 px-3 mb-12">
            <v-flex xs12 v-if="!uploadSuccess && !showProgress">
              <div class="mb-5">
                <small>
                  <div><b>{{ $t('b')}}</b></div>
                  <div>{{ $t('c')}}</div>
                </small>
              </div>
              <v-btn class="upload-btn-wrapper" outlined>
                <v-icon class="mr-2">mdi-file-outline</v-icon>
                <span>{{ $t('d')}}</span>
                <input id="fileButton" type="file" value="upload" class="hidden" accept=".doc,.docx,.pdf"/>
              </v-btn>
            </v-flex>
            <v-flex xs12>
              <span v-if="uploadError" class="red--text">{{ $t('e')}}</span>
            </v-flex>
          </v-layout>
        </v-form>
        <v-layout wrap text-center>
          <v-flex xs12>
            <v-dialog v-model="isCreateDossierPending" width="40%" persistent content-class="vDialogWithoutShadow">
              <v-layout wrap mb-6>
                <v-flex xs12 text-center>
                  <v-avatar :size="225" color="primary">
                    <img :src="images.robot">
                  </v-avatar>
                </v-flex>
              </v-layout>
              <v-card class="px-6 pb-4 pt-4 text-center primary white--text">
                <div><b>{{ $t('f')}}</b></div>
                <v-progress-linear indeterminate color="secondary" class="mt-3"></v-progress-linear>
              </v-card>
            </v-dialog>
          </v-flex>
        </v-layout>
      </v-flex>
    </v-layout>
  </div>
</template>

<script>
export default {
  data: () => ({
    isCreateDossierPending: false,
    uploadedFileUrl: null,
    uploadSuccess: false,
    uploadError: false,
    showProgress: false,
    images: {
      main: require('@/assets/app/images/data_hosting_flatline.svg'),
      robot: require('@/assets/app/images/artificial_intelligence_flatline1.svg')
    },
  }),
  async mounted() {
    const dossierSnap = await this.$db.collection('dossiers').doc(this.$route.params.dossierId).get()
    if (dossierSnap.data().sourceUrl) return this.$router.push(`/consultant/dossiers/${this.$route.params.dossierId}/edit`)
    await this.$functions.httpsCallable('setCustomClaimOfDossierIds')()
    this.initFileUploadButton()
  },
  methods: {
    async createFromFileUpload() {
      this.isCreateDossierPending = true
      
      // Call CF to use this.sourceUrl and process the CV.
      await this.$functions.httpsCallable('consultantTriggerCreateDossierStep2', { timeout: 540 * 1000 })({
        dossierId: this.$route.params.dossierId,
        sourceUrl: this.uploadedFileUrl
      })

      // Wait for processing to be done and then redirect
      const _this = this;
      let unsubcribeFirebaseDossierListener;
      unsubcribeFirebaseDossierListener = this.$db.collection('dossiers').doc(this.$route.params.dossierId).onSnapshot(dossierSnap => {
        const dossier = dossierSnap.data();
        if (dossier.isProfileReady) {
          if (unsubcribeFirebaseDossierListener) unsubcribeFirebaseDossierListener();
          _this.$router.push(`/consultant/dossiers/${this.$route.params.dossierId}/edit`)
        }
      })
    },
    initFileUploadButton() {
      const _this = this;
      const fileButton = document.getElementById('fileButton');

      fileButton.addEventListener('change', function(e) {
        _this.showProgress = true;
        _this.uploadSuccess = false;
        _this.uploadError = false;

        // Get file
        const file = e.target.files[0];

        // Create a storage ref
        const date = new Date().toISOString();
        const fileName = `${file.name.replace(/[^a-zA-Z0-9]+/g, "-")}--${date}`
        const tmpNameArr = fileButton.value.toString().split('.')
        const fileExtension = tmpNameArr[tmpNameArr.length - 1]
        const filePath = `dossiersToAdapt/${fileName}.${fileExtension}`
        const storageRef = _this.$storage.ref(filePath);
        
        // Upload file
        const task = storageRef.put(file);

        // Update progress bar
        task.on('state_changed',
          function progress(snapshot) {
            const percentage = snapshot.totalBytes !== 0 ? Math.round(snapshot.bytesTransferred / snapshot.totalBytes * 100) : 0;
            const uploader = document.getElementById('uploader');
            uploader.value = percentage;
          },
          function uploadError() {
            _this.uploadError = true;
            _this.showProgress = false;
          },
          function complete() {
            _this.uploadSuccess = true;
            _this.showProgress = false;
            _this.uploadedFileUrl = filePath
            _this.createFromFileUpload()
          }
        )
      })
    },
  }
}
</script>




<i18n>
{
  "fr": {
    "a": "Upload de votre CV",
    "b": "Choisissez votre CV le plus complet",
    "c": "Au format Word ou Pdf",
    "d": "Uploader mon CV",
    "e": "Erreur lors de l'upload.",
    "f": "Analyse de votre CV en cours..."
  },
  "en": {
    "a": "Upload your CV",
    "b": "Choose your most detailed CV",
    "c": "File format : Word or Pdf",
    "d": "Upload my CV",
    "e": "An error occurred during the upload.",
    "f": "Analyzing CV..."
  }
}
</i18n>